var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 11.112 11.112",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-118.04 -33.183)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.95238 0 0 .95238 5.8852 1.8446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m118.04 43.297v-9.1165c0-0.13232 0.0258-0.2595 0.0759-0.38156 0.0502-0.12206 0.12307-0.23078 0.21642-0.32412 0.0933-0.09334 0.20205-0.16514 0.32413-0.21642 0.12205-0.05026 0.24924-0.0759 0.38156-0.0759h9.1165c0.13231 0 0.2595 0.02566 0.38158 0.0759 0.12205 0.05128 0.23079 0.12308 0.3241 0.21642 0.0934 0.09334 0.16514 0.20206 0.21642 0.32412 0.0503 0.12206 0.0759 0.24924 0.0759 0.38156v9.1165c0 0.13232-0.0257 0.25951-0.0759 0.38156-0.0513 0.12206-0.12307 0.23078-0.21642 0.32412-0.0933 0.09334-0.20205 0.16616-0.3241 0.21643-0.12208 0.05024-0.24927 0.0759-0.38158 0.0759h-9.1165c-0.13232 0-0.25951-0.0256-0.38156-0.0759-0.12208-0.05024-0.23081-0.12309-0.32413-0.21643-0.0933-0.09334-0.16616-0.20206-0.21642-0.32412-0.0502-0.12205-0.0759-0.24924-0.0759-0.38156z",
    fill: "#0063a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.06 37.199h1.0872v3.4956h-1.0872zm0.54465-1.7375c0.34771 0 0.62977 0.28207 0.62977 0.62978 0 0.34772-0.28206 0.62978-0.62977 0.62978-0.34873 0-0.6308-0.28207-0.6308-0.62978 0-0.34771 0.28207-0.62978 0.6308-0.62978",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.83 37.199h1.0411v0.47798h0.0194c0.21233-0.3631 0.60722-0.57952 1.0278-0.56414 1.1016 0 1.3037 0.72312 1.3037 1.6647v1.917h-1.0862v-1.6996c0-0.40515-7e-3 -0.92724-0.56413-0.92724-0.55798 0-0.65235 0.44003-0.65235 0.89749v1.7293h-1.0852z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ce5105752446b3259d22da68d2468bde.svg";
export { ForwardRef as ReactComponent };